import { TBoardId } from '../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../types/actions';
import { fetchHandler } from '../../../../util/fetchHandler';
import { Util } from '../../../../util/util';
import { REST_BOARD } from '../../../constants';
import { getRestHeadersGet } from '../../../helpers/getRestHeadersHelper';
import { IChatDashboardSettings } from '../../../../store/model/chatDashboardSettings/types';
import { REST_CHAT_DASHBOARD_SETTINGS } from 'app/rest/effects/chatDashboardSettings/api/constans';

export const getRest = (
    boardId: TBoardId
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        return fetchHandler<IChatDashboardSettings>(
            Util.getApiUrl(REST_BOARD + boardId + REST_CHAT_DASHBOARD_SETTINGS), {
                ...getRestHeadersGet()
            }
        );
    };
    return action;
};
